import * as styles from './giftCardRedemption.module.scss';

const TITLE = 'Redeem your Gift Card';

const Title = () => (
  <article className={styles.giftCreditArticle}>
    <h1>{TITLE}</h1>
  </article>
);

export default Title;
